// アカウントページの都道府県書き換え

(function($) {
  'use strict';
  
  theme.AssetsLoader.onPageLoaded(function() {
    theme.customerAddresses = (function() {
      var $newAddressForm = $('#AddressNewForm');
    
      if (!$newAddressForm.length) {
        return;
      }
    
      // Initialize observers on address selectors, defined in shopify_common.js
      if (Shopify) {
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
          hideElement: 'AddressProvinceContainerNew'
        });
      }
    
      // Initialize each edit form's country/province selector
      $('.address-country-option').each(function() {
        var formId = $(this).data('form-id');
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;
    
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector
        });
      });
    
      // Reorder provinces after initialization
      function reorderProvinces(provinceSelector) {
        var provinceSelect = document.getElementById(provinceSelector);
        var provinces = [
          "北海道", "青森県", "岩手県", "宮城県", "秋田県", "山形県", "福島県", 
          "茨城県", "栃木県", "群馬県", "埼玉県", "千葉県", "東京都", "神奈川県",
          "新潟県", "富山県", "石川県", "福井県", "山梨県", "長野県", "岐阜県",
          "静岡県", "愛知県", "三重県", "滋賀県", "京都府", "大阪府", "兵庫県",
          "奈良県", "和歌山県", "鳥取県", "島根県", "岡山県", "広島県", "山口県",
          "徳島県", "香川県", "愛媛県", "高知県", "福岡県", "佐賀県", "長崎県",
          "熊本県", "大分県", "宮崎県", "鹿児島県", "沖縄県"
        ];
    
        // Create new options HTML
        var optionsHtml = provinces.map(function(province) {
          return '<option value="' + province + '">' + province + '</option>';
        }).join('');
    
        // Replace the existing options with the new ordered options
        provinceSelect.innerHTML = optionsHtml;
    
        // Set the default value if necessary
        var defaultProvince = provinceSelect.getAttribute('data-default');
        if (defaultProvince) {
          provinceSelect.value = defaultProvince;
        }
      }
    
      // Use a small delay to ensure Shopify selector is fully initialized
      setTimeout(function() {
        reorderProvinces('AddressProvinceNew');
        $('.address-country-option').each(function() {
          var formId = $(this).data('form-id');
          reorderProvinces('AddressProvince_' + formId);
        });
      }, 1000); // Adjust the delay as necessary
    
      // Toggle new/edit address forms
      $('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hide');
      });
    
      $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
      });
    
      $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
          Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
      });
    })();
  });
})(jQuery);

